<a hybridHref href="{{data?.fields?.Link?.value?.href}}" [attr.aria-label]="data?.fields?.Link?.value?.text" target="{{data?.fields?.Link?.value?.target}}" class="eq-px-4 eq-py-5 lg:eq-p-6 eq-flex eq-gap-6 hover-effect-list-right eq-border-b eq-border-grey-dusty lg:eq-border-0">
  <div class="eq-flex eq-flex-col eq-gap-4 lg:eq-w-4/5">
    <div *ngIf="data?.fields?.WithDate?.value" class="eq-text-body-xs-m-m lg:eq-text-body-xs eq-text-blue-darkBlue">{{data?.fields?.Date.value | date : "dd/MM/YYY"}}</div>
    <h3 class="eq-text-heading6-m lg:eq-text-heading6 eq-text-blue-darkBlue" *scText="data?.fields?.Title"></h3>
    <div class="eq-text-body-sm-m-m lg:eq-text-body-sm eq-text-black-natural-80" *scText="data?.fields?.Subtitle"></div>
  </div>
  <div class="lg:eq-w-1/5 eq-content-center lg:eq-pl-6 hoverClassListRight">
    <i class="eq-icons eq-icon-arrow_right eq-text-[26px]"></i>
  </div>
</a>
